import { Component, EventEmitter, Input, Output } from '@angular/core';

export type TabMenuTabModel = {
  key: string;
  label: string;
  number?: number;
  iconClass: string;
  disabled?: boolean;
};

@Component({
  selector: 'app-tab-menu',
  templateUrl: './tab-menu.component.html',
  styleUrl: './tab-menu.component.scss',
  standalone: false,
})
export class TabMenuComponent {
  @Input() tabs: TabMenuTabModel[] = [];
  @Input() activeTab: string | null = null;
  @Output() tabChange = new EventEmitter<TabMenuTabModel>();

  onTabSelect(tab: TabMenuTabModel): void {
    if (tab.disabled) {
      return;
    }
    this.activeTab = tab.key;
    this.tabChange.emit(tab);
  }
}
